import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import SchoolIcon from "@material-ui/icons/School";
import WorkIcon from "@material-ui/icons/Work";
import "../styles/Experience.css";

function Experience() {
  return (
    <div className="experience">
      <VerticalTimeline lineColor="#A2D2FF">
        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2024 - Present"
          contentStyle={{ borderTop: "6px solid #DE1A1A" }}
          iconStyle={{ background: "#DE1A1A", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Developer & Project Manager
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            The Channel Company
          </h4>
          <p>
            I am responsible for developing 75+ client websites, working
            directly with clients to gather project requirements and deliver
            tailored web solutions. Additionally, I serve as the Developer
            Project Manager on a game development project aimed at internal
            sales teams. In this role, I bridge the gap between the client and
            the development team, managing timelines and ensuring clear
            communication to meet project milestones. I also apply my UX/UI
            design skills by creating detailed wireframes, ensuring smooth
            design implementation and alignment with brand standards.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2022 - Present"
          contentStyle={{ borderTop: "6px solid #08415C" }}
          iconStyle={{ background: "#08415C", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Full-stack Developer
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Red Bags KC Charity
          </h4>
          <p>
            I am leading the digitalization of a charitable organization, aiming
            to establish an interactive database to centralize all
            workflow-related data. To accomplish this, I conducted research to
            identify the most suitable tech stack, including AWS Cloud, React,
            JS, Node.js, and Figma. I am designing and developing the backend
            database architecture using AWS Amplify and AWS Cognito for
            scalability and robustness, and integrated human-centered design
            principles throughout the UX/UI design phase to enhance the user
            experience. Working closely with volunteers, I am ensuring the
            system is user-friendly, intuitive, and implementing version control
            using Git to enable seamless collaboration and track changes.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2022 - 2023"
          contentStyle={{ borderTop: "6px solid #E49AB0" }}
          iconStyle={{ background: "#E49AB0", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Associate Software Engineer Consultant
          </h3>
          <h4 className="vertical-timeline-element-subtitle">Sogeti</h4>
          <p>
            During my time at Sogeti I held a few roles. As a UX/UI Designer, I
            created high fidelity wireframes for a multi-screen concept flow
            using Figma. My responsibilities included researching, ideating
            solutions, prototyping, testing, and refining based on feedback. I
            collaborated with the team, adapting designs based on feedback and
            ensuring accessibility in all design iterations. Additionally, I had
            a solid understanding of responsive design principles. In my role as
            a Front End Analyst, I created a user requirements document that
            detailed over 200 functionalities of a basic workflow processing
            system. I conducted research on processing systems to determine the
            fundamental requirements needed, and analyzed and described in
            detail the events of workflow and document processing, user
            interaction, and system visuals.
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2020 - 2022"
          contentStyle={{ borderTop: "6px solid #A2D2FF" }}
          iconStyle={{ background: "#A2D2FF", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">Web Developer</h3>
          <h4 className="vertical-timeline-element-subtitle">
            University of Kansas IT
          </h4>
          <p>
            Collaborated with a 10-person web development team and communicated
            directly with end-users to design and build custom webpages using
            jQuery, JavaScript, CSS, and HTML to meet clients' needs.
            Additionally, I demonstrated adaptability by quickly learning a new
            website hosting platform and thoroughly understanding its
            functionalities, enabling me to teach others how to use it
            effectively.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2020 - 2022"
          contentStyle={{ borderTop: "6px solid #758E4F" }}
          iconStyle={{ background: "#758E4F", color: "#fff" }}
          icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Bachelor of Science Computer Science
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            University of Kansas
          </h4>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2014 - 2017"
          contentStyle={{ borderTop: "6px solid #E9D35B" }}
          iconStyle={{ background: "#E9D35B", color: "#fff" }}
          icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Graduated High School
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            St. Teresa's Acadeemy
          </h4>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
}

export default Experience;
